import { render } from "./AdminMenus.vue?vue&type=template&id=c996d58e&scoped=true"
import script from "./AdminMenus.vue?vue&type=script&lang=js"
export * from "./AdminMenus.vue?vue&type=script&lang=js"

import "./AdminMenus.vue?vue&type=style&index=0&id=c996d58e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c996d58e"]])

export default __exports__